import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n';
import router from './router'
import VeeValidate from 'vee-validate';
import VueObserveVisibility from 'vue-observe-visibility';
import VueTyperPlugin from 'vue-typer';
import VueScrollReveal from 'vue-scroll-reveal';
//import Lightbox from 'vue-pure-lightbox';

import VueLightbox from 'vue-lightbox';


Vue.component("Lightbox", VueLightbox);
// Vue.use(Lightbox);
Vue.use(VueScrollReveal);
Vue.use(VeeValidate);
Vue.use(VueObserveVisibility);
Vue.use(VueTyperPlugin);

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app2')
